import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const MockupWindowsDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Mockup Windows"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
